<script>
import SpouseInformation from './SpouseInformation.vue'
import DependentInformation from './DependentInformation.vue'

export default {
    components: {
        SpouseInformation,
        DependentInformation
    },
    props: {
        suffixesData: Array,
        relationshipsData: Array,
        maritalStatus: Object,
        spouseInfo: Object,
        dependentDetails: Object
    },
    data() {
        return {
            isShowSpouseInfo: false,
        }
    },
    methods: {
        handleMaritalStatus(value) {
            if(value === 'Single' || value === 'Head Of Household') {
                this.isShowSpouseInfo = false
            } else {
                this.isShowSpouseInfo = true
            }
        },
        addDependnentDetails() {
            this.$emit('addDependent')
        },
        deleteDependentDetails(index) {
            this.$emit('deleteDependent', index)
        }
    },
}
</script>

<template>
    <div>
        <div class="form-group">
            <div class="row mb-2">
                <div class="col-12 col-sm-6 col-md-5 p-2">
                    1. As of December 31st, what was your marital status?
                </div>
                <div class="col-12 col-sm-6 col-md-7 p-2">
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                id="maritalStatusSingle"
                                v-model="maritalStatus.status"
                                value="Single"
                                @click="handleMaritalStatus('Single')"
                            />
                            <label
                                class="form-check-label"
                                for="maritalStatusSingle"
                            >
                                Single
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                id="maritalStatusMarriedFilingJointly"
                                v-model="maritalStatus.status"
                                value="Married Filing Jointly"
                                @click="handleMaritalStatus('Married Filing Jointly')"
                            />
                            <label
                                class="form-check-label"
                                for="maritalStatusMarriedFilingJointly"
                            >
                            Married Filing Jointly
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                id="maritalStatusMarriedFilingSeparately"
                                v-model="maritalStatus.status"
                                value="Married Filing Separately"
                                @click="handleMaritalStatus('Married Filing Separately')"
                            />
                            <label
                                class="form-check-label"
                                for="maritalStatusMarriedFilingSeparately"
                            >
                                Married Filing Separately
                            </label>
                        </div>
                    </div>
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                id="maritalStatusHeadHousehold"
                                v-model="maritalStatus.status"
                                value="Head Of Household"
                                @click="handleMaritalStatus('Head Of Household')"
                            />
                            <label
                                class="form-check-label"
                                for="maritalStatusHeadHousehold"
                            >
                            Head of Household
                            </label>
                        </div>
                    </div>
                    
                    <div class="form-group form-check-inline">
                        <div
                            class="form-check"
                        >
                            <input
                                class="form-check-input"
                                type="radio"
                                id="maritalStatusQualifyingWidow"
                                v-model="maritalStatus.status"
                                value="Qualifying Widow"
                                @click="handleMaritalStatus('Qualifying Widow')"
                            />
                            <label
                                class="form-check-label"
                                for="maritalStatusQualifyingWidow"
                            >
                            Qualifying Widow(er)
                            </label>
                        </div>
                    </div>
                    <div
                        v-if="maritalStatus.error"
                        class="text-danger"
                        style="font-size: 80%;"
                    >
                        {{ maritalStatus.error }}
                    </div>
                </div>
            </div>
        </div>
        <SpouseInformation 
            v-if="isShowSpouseInfo"
            :suffixesData="suffixesData"
            :spouseInfo="spouseInfo"
        />
        <DependentInformation 
            :suffixesData="suffixesData"
            :relationshipsData="relationshipsData"
            :dependentDetails="dependentDetails"
            @addDependnentDetails="addDependnentDetails"
            @deleteDependentDetails="deleteDependentDetails"
        />
    </div>
</template>